var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}},[_c('path',{attrs:{"d":"M28.7,42.2c-1.8,2.6-5.6,2.6-7.4,0l-19-27.9c-2-3,0.1-7,3.7-7h38c3.6,0,5.7,4,3.7,7L28.7,42.2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }